<div *ngIf="formEvent.value as event" class="content">
  @if (event?.openHouseParentEvent) {
  <div class="text-primary">Visita Openhouse</div>
  } @if ($any(event?.type) === 20) {
  <div class="text-primary">Evento principale Openhouse</div>
  } @if (!isFormEnabled) {
  <div class="text-danger text-center my-3">L'appuntamento è già stato esitato e non è possibile modificarlo ulteriormente.</div>
  } @if (event?.propertyAddress ) {
  <div class="text-danger text-center my-3">Indirizzo opportunità: {{event?.propertyAddress}}</div>
  } @else {
  <div class="text-info my-3">Indirizzo opportunità: {{$any(event)?.contactObj?.address?.formatted_address}}</div>
  }
  <form [formGroup]="formEvent" (submit)="save()">
    <div class="flex flex-col justify-between gap-3">
      @if (event.type != 17) {
      <p-dropdown styleClass="w-full" formControlName="state" [options]="(eventStateOptions$ | async) ?? []" placeholder="Stato" />
      } @if (event.state !== EventState.CONTESTATO) {
      <textarea formControlName="note" rows="5" cols="30" class="w-full" placeholder="Note" pInputTextarea></textarea>
      <textarea
        formControlName="oldNote"
        rows="5"
        cols="30"
        class="w-full"
        placeholder="Note attività precedente"
        pInputTextarea
      ></textarea>
      } @if (event.state === EventState.CONTESTATO) {
      <ng-container formGroupName="dispute" class="flex flex-col gap-3">
        <div>
          <textarea formControlName="note" rows="5" cols="30" class="w-full" placeholder="Note" pInputTextarea></textarea>
        </div>
        <div class="flex justify-end">
          <p-dropdown formControlName="reason" [options]="(disputeReasonOptions$ | async) ?? []" placeholder="Motivo contestazione" />
        </div>
      </ng-container>
      }
    </div>
    @if (event.state === EventState.RIPROGRAMMATO) {
    <div class="flex flex-col gap-3 mt-3" formGroupName="reschedule">
      <div class="flex justify-between items-baseline gap-3">
        <p-calendar
          id="newDate"
          appendTo="body"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          placeholder="Nuova data"
          formControlName="newDate"
          (ngModelChange)="checkAgentAvailability()"
          [ngClass]="{'ng-invalid ng-dirty': formEvent.get('reschedule')?.get('newDate')?.invalid && formEvent.get('reschedule')?.get('newDate')?.touched}"
        ></p-calendar>
        <p-dropdown 
          [options]="slotList" 
          placeholder="Nuovo orario" 
          formControlName="newStart" 
          appendTo="body" 
          styleClass="w-40"
          [ngClass]="{'ng-invalid ng-dirty': formEvent.get('reschedule')?.get('newStart')?.invalid && formEvent.get('reschedule')?.get('newStart')?.touched}"
        />
        <p-dropdown
          formControlName="reason"
          appendTo="body"
          [options]="(disputeReasonOptions$ | async) ?? []"
          styleClass="w-60"
          placeholder="Motivo contestazione"
        />
      </div>
      <div class="flex flex-col gap-3 mt-3">
        <div class="flex flex-col">
          <h4 class="text-xl">Comunicazione al cliente</h4>
        </div>
        <div class="flex gap-3">
          <p-radioButton
            [value]="false"
            name="bypassReminder"
            formControlName="bypassReminder"
            label="Sì, invia nuovo promemoria"
          ></p-radioButton>
          <p-radioButton [value]="true" name="bypassReminder" formControlName="bypassReminder" label="No. Non inviare"></p-radioButton>
        </div>
      </div>
    </div>
    }

    <div class="flex justify-end gap-3 mt-3">
      <button pButton type="submit" [disabled]="!isFormEnabled">Conferma</button>
    </div>
  </form>
</div>
